import { Button } from "@components/button";
import Spinner from "@components/spinner";
import React from "react";

interface OnboardingFooterProps {
  onNext: (e?: React.MouseEvent) => void;
  onBack?: () => void;
  onSkipForNow?: () => void;
  isLoading?: boolean;
  nextButtonText?: string;
  backButtonText?: string;
  skipButtonText?: string;
  isNextDisabled?: boolean;
  isBackDisabled?: boolean;
  showSkipForNow?: boolean;
}

export const OnboardingFooter: React.FC<OnboardingFooterProps> = ({
  onNext,
  onBack,
  onSkipForNow,
  isLoading = false,
  nextButtonText = "Next",
  backButtonText = "Previous",
  skipButtonText = "Next, skip for now",
  isNextDisabled = false,
  isBackDisabled = false,
  showSkipForNow = true,
}) => {
  return (
    <div className="py-6 w-full border-t border-azure-radiance-100" data-testid="onboarding-footer">
      <div className="xs:mx-4 sm:mx-6 md:mx-12 lg:mx-24 flex grow items-center justify-between">
        {onBack ? (
          <Button
            className="w-[250px] text-xl"
            variant="outline"
            size="giant"
            disabled={isBackDisabled}
            onClick={onBack}
            type="button"
            data-testid="onboarding-back-button"
          >
            {backButtonText}
          </Button>
        ) : (
          <span />
        )}
        <div className="flex items-center gap-4">
          {onSkipForNow && showSkipForNow && (
            <Button
              className="text-md hover:bg-gray-50"
              type="button"
              variant="link"
              onClick={onSkipForNow}
              data-testid="onboarding-skip-button"
            >
              {skipButtonText}
            </Button>
          )}
          <Button
            variant="outline"
            size="giant"
            className="w-[250px] text-xl"
            disabled={isLoading || isNextDisabled}
            onClick={onNext}
            type="submit"
            data-testid="onboarding-next-button"
            aria-busy={isLoading}
          >
            {isLoading ? <Spinner data-testid="onboarding-next-loading" /> : nextButtonText}
          </Button>
        </div>
      </div>
    </div>
  );
};
